import React from 'react';
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { drillChartColor } from './colors';

export type DonutSlice = {
  name: string;
  value: number;
  color?: string;
};

export function DrillDonutChart({
  slices,
  fmtVal,
  height = 150,
  innerRadius = 42,
  outerRadius = 62,
}: {
  slices: DonutSlice[];
  fmtVal?: (v: number) => string;
  height?: number;
  innerRadius?: number;
  outerRadius?: number;
}) {
  const data = slices.filter(s => s.value > 0);
  if (!data.length) return null;
  const total = data.reduce((a, s) => a + s.value, 0) || 1;

  return (
    <div className="ddrill-chart ddrill-donut" style={{ height }} onClick={e => e.stopPropagation()}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Tooltip
            formatter={(value: number, name: string) => {
              const pct = Math.round((value / total) * 100);
              const label = fmtVal ? fmtVal(value) : String(value);
              return [`${label} (${pct}%)`, name];
            }}
            contentStyle={{
              background: 'var(--surface)',
              border: '1px solid var(--line)',
              borderRadius: 8,
              fontSize: 12,
            }}
          />
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={2}
            isAnimationActive={false}
          >
            {data.map((s, i) => (
              <Cell key={s.name} fill={s.color ?? drillChartColor(i)} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
